import { SelectOption } from "@/components/elements/select";
import { TypesCoupon } from "@/entities/api/coupons/coupons";

export const couponTypesOptions: SelectOption[] = [
    { label: 'Monto', value: TypesCoupon.AMOUNT },
    { label: 'Porcentaje', value: TypesCoupon.DISCOUNT },
]
